import { render, staticRenderFns } from "./IntegrationSpiris.vue?vue&type=template&id=1287b366&scoped=true"
import script from "./IntegrationSpiris.vue?vue&type=script&lang=js"
export * from "./IntegrationSpiris.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSpiris.vue?vue&type=style&index=0&id=1287b366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287b366",
  null
  
)

export default component.exports